'use strict';

/**
 * A provider that builds routes for an inspiration detail view for any given state name.
 * Example:
   $stateProvider
    .state(baseState)
    .state(InspirationDetailRouterProvider.buildRoutes(baseState.name).modal)
    .state(InspirationDetailRouterProvider.buildRoutes(baseState.name).detail);
*/

(function () {
  'use strict';

  angular.module('vnext').provider('InspirationDetailRouter', InspirationDetailRouter);

  var inspirationModalState = {
    name: '.modal',
    url: '',
    abstract: true,
    params: {
      browseable: null
    },
    data: {
      noScroll: true
    },
    views: {
      'inspirationModal': {
        controller: ['$scope', 'NotifyingSvc', '$timeout', '$stateParams', function ($scope, NotifyingSvc, $timeout, $stateParams) {
          // $timeout is required here (https://github.com/dwmkerr/angular-modal-service/issues/172)
          $timeout(function () {
            NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
              templateUrl: 'vnext/pages/inspirations/inspiration-modal.html',
              controller: 'InspirationsModalCtrl',
              // A new scope will be created as a child of this state's parent.
              scope: $scope.$parent,
              // If this $state was reached by clicking an inspiration-card (as opposed to a deep-link or page reload),
              // add the parent $state's collection of inspirations to the modal.
              // Otherwise, only one inspiration will be displayed in the view.
              inputs: {
                allInspirations: $stateParams.browseable ? $scope.$parent.vm.inspirations : null
              },
              closeCallback: function closeCallback(allInspirations) {
                // If there are more inspirations after closing this modal than when we opened it, merge the two arrays.
                // This means the user reached the next page of inspirations in the modal, and they need to be returned
                // to the parent state.
                // If they are not returned to the parent state, the page index in inspirationSvc needs to be reset to 0.
                if (_.get(allInspirations, 'length') > $scope.$parent.vm.inspirations.length) {
                  angular.extend($scope.$parent.vm.inspirations, allInspirations);
                }
              }
            });
          });
        }]
      }
    }
  };

  var inspirationDetailState = {
    name: '.modal.detail',
    url: '/detail/{url}',
    views: {
      'inspiration@': {
        templateUrl: 'vnext/pages/inspirations/inspiration-detail.html',
        controller: 'InspirationsDetailCtrl',
        controllerAs: '$ctrl'
      }
    },
    resolve: {
      inspiration: ['inspirationSvc', '$stateParams', 'preloader', '$filter', '$log', 'errorRouter', function (inspirationSvc, $stateParams, preloader, $filter, $log, errorRouter) {
        preloader.preloadImageUrlString($filter('msImgixSrc')($stateParams.url, 'largeLandscape'));
        var inspFromParams = _.findLast($stateParams.allInspirations, function (i) {
          return i.url === $stateParams.url;
        });
        return inspFromParams ? inspFromParams : inspirationSvc.get($stateParams.url).then(function (data) {
          return data;
        }, function (resp) {
          $log.debug(resp);
          errorRouter.navigateError({
            message: 'The Inspiration <strong>' + $stateParams.url + '</strong> you are looking for is not available right now.' + '<br/><br/>' + 'Try to find another one <b><a href="/v/browse">here</a></b>',
            errorCode: resp.status,
            contact: false
          });
        });
      }]
    },
    onEnter: ['NotifyingSvc', 'inspiration', function (NotifyingSvc, inspiration) {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PAGE_TITLE, {
        pageTitle: inspiration.title
      });
    }]
  };

  function InspirationDetailRouter() {
    var provider = this;
    provider.buildRoutes = buildRoutes;
    provider.$get = [buildRoutes];

    /**
     * Build a new route based upon a parent route's name.
     * @param  {Object} A uiRouter state object
     * @param  {String} Parent State's full name
     * @return {Object} A new uiRouter state object with the parent's name prepended to its name.
     */
    function _buildChildState(childStateBase, parentStateName, baseRoutePrefix) {
      var childState = angular.copy(childStateBase);
      childState.name = baseRoutePrefix + childStateBase.name;
      childState.parent = baseRoutePrefix + parentStateName;
      return childState;
    }

    /**
     * Configure the provider context and build the route defns
     * @param  {String} baseRoutePrefix the base prefix for all routes in this context
     * @return {Object} An object containing both states.
     */
    function buildRoutes(baseRoutePrefix) {
      //build the routes
      var modal = _buildChildState(inspirationModalState, '', baseRoutePrefix);
      var detail = _buildChildState(inspirationDetailState, inspirationModalState.name, baseRoutePrefix);
      return { modal: modal, detail: detail };
    }
  }
})();